export default {
  votedOn: "Votado el",
  downloadDetails: "Descargar detalle (pdf)",
  timeRemaining: "Estado",
  startsIn: "Comienza en",
  days: "días",
  participants: "Votos",
  voting: "Votación",
  anonymousAndSecure: "Anónima y segura",
  sectionDescription: "¡Participa en las decisiones que te afectan!",
  votes: "votos",
  vote: "voto",
  voted: "Votado",
  won: "Ganado",
  selectOption: "Seleccionar",
  selectedOption: "Seleccionado",
  info: {
    revote:
      "Una vez votes, podrías volver a votar. El último voto que hagas antes del cierre de la votación será el que contará.",
    anonymous: "Tu voto será anónimo y se registrará de forma segura en la blockchain.",
  },
  error: {
    votingNotFound: "Votación no encontrada",
  },
  cannotVoteInfo: {
    title: "¿Por qué no puedo votar?",
    message:
      "Para votar es necesario que tu cuenta aparezca como verificada y solamente podrás participar en las consultas nuevas creadas a partir del momento de esa validación.\n\n¡Bienvenido!",
  },
  secondRound: {
    title: "Segunda vuelta",
    message:
      "Dado que no se ha llegado a tener mayoría (+51%), se realizará una segunda vuelta con los dos candidatos/as que han tenido más votos.",
  },
}
